import { useMemo } from "react";
import { qrModules } from "@/lib/paystack";

/** A crisp QR code (SVG) with a white quiet zone, so it scans off any screen. */
export function Qr({ text, size = 240, label }: { text: string; size?: number; label: string }) {
  const { n, path } = useMemo(() => {
    const m = qrModules(text);
    let d = "";
    m.forEach((row, y) => row.forEach((on, x) => {
      if (on) d += `M${x + 4} ${y + 4}h1v1h-1z`;
    }));
    return { n: m.length + 8, path: d };
  }, [text]);
  return (
    <svg role="img" aria-label={label} width={size} height={size} viewBox={`0 0 ${n} ${n}`} shapeRendering="crispEdges" className="block bg-white">
      <rect width={n} height={n} fill="#ffffff" />
      <path d={path} fill="#101214" />
    </svg>
  );
}
